import{__require as r}from"./to-primitive.js";import{__require as i}from"./is-symbol.js";var e,t;function o(){if(t)return e;t=1;var o=r(),n=i();return e=function(r){var i=o(r,"string");return n(i)?i:i+""}}export{o as __require};
//# sourceMappingURL=to-property-key.js.map
